module.exports = __webpack_public_path__ + "static/media/setup-payment-run.e4a94c40.png";